<section class="container-wrapper">
  <div>
    <h1 class="module-heading">
      {{ 'pages.user-requests.list.heading' | translate }}
      <div class="loading-spinner" *ngIf="loading">
        <mat-progress-spinner
          mode="indeterminate"
          diameter="20">
        </mat-progress-spinner>
      </div>
    </h1>
    <div class="scrollable">
      <app-bciti-table
        *ngIf="userRequests.length > 0; else elseBlock"
        [tableData]="userRequests"
        [htmlProperties]="htmlProperties"
        [length]="pageOptions.length"
        [pageIndex]="pageOptions.page"
        [pageSize]="pageOptions.pageSize"
        routerLinkActive="router-link-active"
        [columnHeader]="columnHeaders"
        [actionMenuData]="actionMenu"
        (page)="pageChange($event)"
        (actions)="handleActions($event)">
      </app-bciti-table>
      <ng-template #elseBlock>
        <p>{{ 'pages.user-requests.list.table.no-data' | translate }}</p>
      </ng-template>
    </div>
  </div>
</section>